import { Component, HostBinding } from '@angular/core';

import { FirebaseService } from '../../services/firebase.service';

import { environment } from '../../../environments/environment';

@Component({
	selector    : 'header-bar',
	templateUrl : 'header.html',
	styleUrls   : [ 'header.scss' ]
})

export class HeaderComponent {
	@HostBinding('class.menu-active') menuActive  : boolean = false;
	@HostBinding('class.--animate')   animateMenu : boolean = false;

  title         : string = 'Cartmigo';
  env           : string = environment.env;

	constructor(
    private firebaseService : FirebaseService
  ) {}

	public showMenu() : void {
		this.showHideMenu(true);
	}

  public hideMenu(animate : boolean = true) : void {
  	this.showHideMenu(false, animate);
  }

  private showHideMenu(active : boolean, animate : boolean = true) : void {
  	this.animateMenu = animate;
  	this.menuActive  = active;

  	setTimeout(() => this.animateMenu = false, 300);
  }

  private menuClick(event) : void {
  	event.stopPropagation();

  	// if click target is a link or button,
  	// hide menu w/out animation
  	if (event.target.nodeName === 'A' || event.target.nodeName === 'BUTTON')
  		this.hideMenu(false);
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/header/header.ts